export var formatDateToLocaleString = function (date, yearFormat) {
    if (yearFormat === void 0) { yearFormat = '2-digit'; }
    return new Date(date).toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: yearFormat,
    });
};
export var getNextYearToday = function () {
    var today = new Date();
    var nextYearToday = new Date(today.setFullYear(today.getFullYear() + 1));
    return formatDateToLocaleString(nextYearToday, 'numeric');
};
export var getDaysBetweenTwoTS = function (startTS, endTS) {
    return Math.floor((endTS - startTS) / 1000 / 60 / 60 / 24);
};
export var getWeekBegin = function () {
    var now = new Date();
    var next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (8 - now.getDay()));
    return next;
};
